import React from 'react';
import { Chip as Chip$2 } from './component.js';
import { Chip as Chip$1 } from './component.legacy.js';

var Chip = function Chip(props) {
  if (props.renderAsLegacy) {
    return /*#__PURE__*/React.createElement(Chip$1, props);
  } else {
    return /*#__PURE__*/React.createElement(Chip$2, props);
  }
};

export { Chip };